import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.circle   = json.circle
      this.title    = json.title
      this.columns  = json.columns

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries  = json.sundries
      



    },

  }
}